import { render } from "./Header.vue?vue&type=template&id=605db6f6&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=605db6f6&scoped=true&lang=css"

import exportComponent from "F:\\unilearn\\unilearn-web-vue3\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605db6f6"]])

export default __exports__